import { Children, ReactNode } from 'react';
import Stack from '@mui/material/Stack';
import { PropertyListSize } from '@/common/components/property-list/types.ts';
import { PropertyItem } from '@/common/components/property-list/subcomponents/property-item/PropertyItem.tsx';
import Divider from '@mui/material/Divider';

export interface PropertyListProps {
  children?: ReactNode;
  size?: PropertyListSize;
}

export const PropertyList = ({ children, size = 'normal' }: PropertyListProps) => {
  const childrenCount = Children.count(children);
  return (
    <Stack gap={size === 'normal' ? 1.5 : 1}>
      {Children.map(children, (child, idx) =>
        idx + 1 === childrenCount ? (
          child
        ) : (
          <>
            {child}
            <Divider />
          </>
        )
      )}
    </Stack>
  );
};

PropertyList.Item = PropertyItem;
